import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./(shared)/full/layouts-routing').then(m => m.routes)
  },
  {
    path: 'auth',
    loadChildren: () => import('./(modules)/(authentication)/routes/authentication-routing.module').then(m => m.routes)
  },
  {
    // PUBLIC — ADNOC Design System showcase. No auth guard / MSAL: reachable
    // directly by URL and from Settings. Renders standalone (outside the app shell).
    path: 'adnoc-design-system',
    loadComponent: () =>
      import('./theme/adnoc/showcase/adnoc-showcase.component').then(m => m.AdnocShowcaseComponent),
    data: { preload: false }
  },
  {
    // DEV-ONLY light-theme QA harness for the map popups/dialogs (no auth, outside
    // the shell). Renders the real popup components unconditionally with mock data
    // so they can be verified against the DLS in light/dark. Not linked in the UI.
    path: 'light-theme-qa',
    loadComponent: () => import('./theme/qa/map-popup-qa.component').then(m => m.MapPopupQaComponent),
    data: { preload: false }
  },
  {
    path: '**',
    redirectTo: '/auth'
  }
];
